import getValidAddOnsByPlan from './getValidAddOnsByPlan'
import redirectQuotes from 'core/DOM/redirectQuotes'
import getURLParams from 'utils/DOM/getURLParams'
import getPlanByPlanId from './getPlanByPlanId'
import isArray from 'utils/validation/isArray'
import store from 'utils/store/withMiddleware'
import descSort from 'utils/descSort'
import { getBenefits } from './getBenefits'
import addChildOnlyPropertyToPlans from 'core/controllerPlans/addChildOnlyPropertyToPlans'
import { propAccessor } from '@hc-frontend/utils'
import isNumber from 'utils/number/isNumber'
import ascSort from 'utils/ascSort'

const identifyPeriod = ({ plan, urlPlan, signedDetails }) => {
  if (signedDetails) {
    return [+signedDetails.plan.period, false]
  }

  if (plan.durations[urlPlan.period]) {
    return [urlPlan.period, false]
  }

  return [+Object.keys(plan.durations).sort(descSort)[0], true]
}

function handleResponseFromEndpoints([responsePlans, recEngine]) {
  const paramsURL = getURLParams()
  const state = store.getState()

  const responseError = !responsePlans || responsePlans.hasError
  const possiblePlanId =
    paramsURL.planid || propAccessor(state, 'signedDetails.plan.planId')

  if (responseError || !possiblePlanId) {
    return redirectQuotes(paramsURL)
  }

  const plans = responsePlans.plans
  const plansMultiCarrier = Object.entries(plans)
    .map(plan => plan[1])
    .filter(plan => plan?.multiCarrierPlan)

  const planList = [
    ...responsePlans.plansSTM,
    ...(isArray(responsePlans.plansBTM) ? responsePlans.plansBTM : []),
    ...(isArray(responsePlans.plansFBM) ? responsePlans.plansFBM : []),
    ...plansMultiCarrier.map(plan => plan.planId)
  ]

  responsePlans.plans = addChildOnlyPropertyToPlans(
    responsePlans.plans,
    responsePlans.childOnlyProductLines
  )

  const urlPlan = getPlanByPlanId({
    planList,
    plans: responsePlans.plans,
    period: responsePlans.filters.period,
    id: possiblePlanId
  })
  const plan = responsePlans.plans[urlPlan.id]

  if (!plan) {
    return redirectQuotes(paramsURL)
  }

  const [period, showAlternativeCoverageByPeriod] = identifyPeriod({
    plan,
    urlPlan,
    signedDetails: state.signedDetails
  })
  let showAlternativeCoverage = showAlternativeCoverageByPeriod

  responsePlans.filters.period = period

  let policies: number | undefined
  if (plan.multiCarrierPlan) {
    policies = +paramsURL.policies
  } else if (paramsURL.policies) {
    const tempPolicy = +paramsURL.policies
    policies = plan.durations[period][tempPolicy]
      ? tempPolicy
      : Math.max(...Object.keys(plan.durations[period]))
  }
  if (policies == null) {
    policies = +Object.keys(plan.durations[period]).sort(ascSort)[0]
    showAlternativeCoverage = true
  }
  responsePlans.filters.policies = policies != null && isNumber(policies) ? policies : 1

  const addonsByPlan = state.hcStorage.addonsByPlan || {}
  const addonsExternalByPlan = state.hcStorage.addonsExternalByPlan || {}

  const validatedAddons = getValidAddOnsByPlan(plan, state.hcStorage.addOn)
  if (paramsURL.add_on) {
    addonsByPlan[plan.planId] = validatedAddons
  }

  const addOns = addonsByPlan[plan.planId] || []

  responsePlans.plans[plan.planId].benefits = getBenefits(plan)

  const externalPlanSelected =
    state.hcStorage.externalPlanSelected || paramsURL.externalPlanId
  const selectedBenefitLevels = state.hcStorage.selectedBenefitLevels || {}

  return {
    ...responsePlans,
    period,
    showAlternativeCoverage,
    addOns,
    endDate: state.hcStorage.endDate,
    sDate: state.hcStorage.sdate,
    showMissedModal: true,
    typeOfPay: 'monthly',
    planId: plan.planId,
    loading: false,
    recEngine,
    addonsByPlan,
    addonsExternalByPlan,
    planHasChanged: urlPlan.hasChanged,
    membersEligibleForChildOnly: plan.isChildOnly,
    externalPlanSelected,
    selectedBenefitLevels
  }
}

export default handleResponseFromEndpoints
